import { call, put } from "redux-saga/effects";
import { createVersion, getPaginationVersions, getVersions } from "../requests/versions";
import { setPaginationVersions, setVersions } from "../../entities/versions";
import { toast } from "react-toastify";
import resources from "../../../core/Localization/Localization";
import { push } from "redux-first-history";

export function* handleGetVersions(action) {
    try {
        const response = yield call(getVersions);
        const { data } = response;
        yield put(setVersions({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleCreateVersion(action) {
    try {

        const response = yield call(createVersion, action.payload);
        const { data } = response;
        //  yield put(setUser({ ...data }));
        yield put(push(`/admin/versions`));
        toast.success(resources.createVersion.success);
    } catch (error) {
        console.log(error);
    }

}
export function* handleGetPaginationVersions(action) {
    try {
        const response = yield call(getPaginationVersions);
        const { data } = response;
        yield put(setPaginationVersions({ ...data }));
    } catch (error) {
        console.log(error);
    }

}
